<template>
  <v-chip
    :color="getOptions().color"
    outlined
    pill
    small
    dense
    light
  >
    <v-icon small left v-text="getOptions().icon">
    </v-icon>
    {{getOptions().text}}
    <v-icon small right @click="showPOUserDialog = true" v-if="canEdit">
      mdi-account-edit
    </v-icon>
    <poUserDialog
      v-model="showPOUserDialog"
      :user="user"
      @onUserCreate="onUserCreate"
      @onUserLocked="onUserLocked"
      @onUserUnlocked="onUserUnlocked"
      @onUserRoleChanged="onUserRoleChanged"
    />
  </v-chip>
</template>

<script>
import poUserDialog from '@/components/modules/org/structure/staff/dialogs/setPOUserDialog.vue'
export default {
  props: ['user', 'mode'],
  components: {
    poUserDialog
  },
  data () {
    return {
      showPOUserDialog: false
    }
  },
  computed: {
    userRole: {
      get: function () {
        return Number(this.$store.getters.getUserRole)
      }
    },
    canEdit: {
      get: function () {
        var res = this.mode === 'edit' && this.userRole !== 9
        return res
      }
    }
  },
  methods: {
    onUserCreate (val) {
      this.$emit('onUserCreate', val)
    },
    onUserLocked (val) {
      this.$emit('onUserLocked', val)
    },
    onUserUnlocked (val) {
      this.$emit('onUserUnlocked', val)
    },
    onUserRoleChanged (val) {
      this.$emit('onUserRoleChanged', val)
    },
    getOptions () {
      const result = {
        color: 'black',
        icon: 'mdi-pan',
        text: ''
      }
      switch (this.user.IS_ACTIVE_USR) {
        case '-3':
          result.color = 'deep-orange'
          result.icon = 'mdi-account-off-outline'
          result.text = 'Блокирован'
          break
        case '0':
          result.color = 'teal'
          result.icon = 'mdi-account-check-outline'
          result.text = 'Активен'
          break
        default:
          result.color = 'blue-grey'
          result.icon = 'mdi-account-minus-outline'
          result.text = 'Не является'
          break
      }
      return result
    }
  }
}
</script>
